enum TipoReceitaArquivo {
    Receita = 1,
    ComprovanteFinanceiro = 2,
    AutenticacaoReceita = 3,
}

export default TipoReceitaArquivo;
